import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=c5d5996e&scoped=true&"
import script from "./Author.vue?vue&type=script&lang=js&"
export * from "./Author.vue?vue&type=script&lang=js&"
import style0 from "./Author.vue?vue&type=style&index=0&id=c5d5996e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d5996e",
  null
  
)

export default component.exports